import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import { withRouter } from 'react-router';
import { WorkflowGetList } from '../../../redux/actions/tracker/workflowActions';
import store from './../../../store';
import { Paper, TextField, FormControl, InputLabel, Typography, Select, MenuItem, Button } from '@material-ui/core';
import Upload from './../../../../node_modules/rc-upload';
import { API_URL } from './../../../constants';
import PageBase from '../../../app/PageBase';

const styles = {
  textField: {
    marginTop: 20,
    marginLeft: 20,
    marginRight: 20,
    marginBottom: 20,
    width: 200,
  },
  input: {
    display: 'none',
  },
};

class InvoiceCreateLot extends Component {

  static propTypes = {
    data: PropTypes.any,
  };

  constructor(props) {

    super(props);

    this.state = {
      workflowId: 0,
      companyId: 0,
      userId: 0,
      expiration: 0,
      workflows: [],
    };

    const user = store.getState().auth.user;

    this.uploadProps = {
      action: `${API_URL}Invoice/InsertInvoiceLot`,
      accept: '.xml',
      withCredentials: true,
      headers: {
        Authorization: `Bearer ${user.access_token}`,
      },
      multiple: true,
      beforeUpload: this.beforeUpload,
      onProgress: this.onProgress,
      onSuccess: this.onSuccess,
      onError: this.onError,
      onStart: this.onStart,
    };

  }

  // #region Events
  onStart(file) {

    console.log('onStart', file.name);
    // this.refs.inner.abort(file);

  }

  beforeUpload(file) {

    console.log('beforeUpload', file.name);

  }
  onProgress(step, file) {

    console.log('onProgress', Math.round(step.percent), file.name);

  }

  onSuccess(file) {

    console.log('onSuccess', file);

  }

  onError(evt, response, err) {

    console.log('onError', err);
    if (err.status === 401)
      console.log('Unauthoraz');

  }
  // #endregion Events

  componentWillMount = () => {

    const holdingId = this.props.user.context.idHolding;

    WorkflowGetList(holdingId).then(workflows => this.setState({ workflows }));

  }

  handleChange = name => (event) => {

    this.setState({
      [name]: event.target.value,
    });

  };

  render() {

    const { workflowId, expiration, workflows } = this.state;
    const user = store.getState().auth.user;

    return (
      <div>
        <PageBase
          title={I18n.t('titles.lotInsert')}
          showCreateButton={false}
          showEditButton={false}
          showDeleteButton={false}
        >

          <FormControl style={styles.textField}>
            <InputLabel htmlFor="workflowId">{I18n.t('fields.workflow')}</InputLabel>
            <Select
              value={workflowId}
              onChange={this.handleChange('workflowId')}
              name="workflowId"

            >
              {workflows.map(item => (
                <MenuItem value={item.workFlowId}>{item.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            id="expiration"
            label={`${I18n.t('fields.expiration_time')}  (${I18n.t('fields.in_hours')})`}
            value={expiration}
            onChange={this.handleChange('expiration')}
            style={styles.textField}
            margin="normal"
            autoComplete="true"
            type="number"
          />
          {
            workflowId ? <Upload
              {...this.uploadProps}
              style={{ display: 'inline-block' }}
              data={{
                workflowId,
                companyId: user.context.idCompany,
                userId: user.IdUser,
                expiration,
              }}
            >

              <Button
                variant="contained"
                color="primary"
                autoFocus
              >
                {I18n.t('button.create')}
              </Button>
            </Upload> : <span>&nbsp;</span>
          }
        </PageBase>
      </div>
    );

  }

}

export default withRouter(InvoiceCreateLot);



// WEBPACK FOOTER //
// ./src/components/tracker/Invoice/InvoiceCreateLot.js